var exports = {
  "Io": "pill__tzG-XM",
  "s6": "pillButton__QbgZdF",
  "Nf": "branchOnlyButton__r53jn7",
  "zJ": "repoButton__kP1nkm",
  "ZG": "branchButton__-hC-kH",
  "$J": "pillChevron__RUtxQb",
  "_v": "pillRemove__pb7xVf",
};

module.exports = exports;
